export enum claimType {
  standard = "standard",
  custom = "custom",
}
